/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsRhombus: {
  name: 'rhombus';
  data: string;
} = {
  name: 'rhombus',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M10.586 3a2 2 0 0 1 2.828 0L21 10.586a2 2 0 0 1 0 2.828L13.414 21a2 2 0 0 1-2.828 0L3 13.414a2 2 0 0 1 0-2.828L10.586 3ZM12 4.414 4.414 12 12 19.586 19.586 12 12 4.414Z" fill="currentColor"/></svg>`,
};
